import React, {useState, useEffect} from "react";
import {Link} from "react-scroll";
import {NavLink} from "react-router-dom";
import Logo from "../../images/site_logo/logo.png";

import MobileMenu from "../MobileMenu/MobileMenu";

const Header = props => {
  const [mobailActive, setMobailState] = useState(false);

  const [isSticky, setSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <header className={`site_header  ${isSticky ? "sticky" : ""}`}>
      <div className="nav_wrapper">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-3 col-5 d-flex align-items-center">
              <div className="site_logo">
                <NavLink className="site_link" to="/" onClick={ClickHandler}>
                  <img
                    loading="lazy"
                    src={Logo}
                    alt="ICO Site Logo"
                    style={{
                      filter: "invert(1)",
                      height: "60px",
                    }}
                  />
                </NavLink>
              </div>
            </div>
            <div className="col-lg-6 col-2">
              <nav className="main_menu navbar navbar-expand-lg">
                <div
                  className={`main_menu_inner collapse navbar-collapse justify-content-center ${
                    mobailActive ? "show" : ""
                  }`}
                  id="main_menu_dropdown"
                >
                  <ul className="main_menu_list unordered_list text-uppercase main-menu">
                    <li>
                      <Link
                        to="id_ico_about_section"
                        spy={true}
                        smooth={true}
                        duration={500}
                        offset={-100}
                        className="nav-link scrollspy_btn"
                      >
                        <span
                          className="nav_link_label"
                          data-text="Nuestras ventajas"
                        >
                          Nuestras ventajas
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="id_ico_solution_section"
                        spy={true}
                        smooth={true}
                        duration={500}
                        offset={-100}
                        className="nav-link scrollspy_btn"
                      >
                        <span
                          className="nav_link_label"
                          data-text="¿Por qué CruCoin?"
                        >
                          ¿Por qué CruCoin?
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="id_ico_contact_section"
                        spy={true}
                        smooth={true}
                        duration={500}
                        offset={-100}
                        className="nav-link scrollspy_btn"
                      >
                        <span className="nav_link_label" data-text="Contacto">
                          Contacto
                        </span>
                      </Link>
                    </li>
                  </ul>
                  <MobileMenu />
                </div>
              </nav>
            </div>
            <div className="col-lg-3 col-5">
              <ul className="btns_group unordered_list p-0 justify-content-end">
                <li className="d-lg-none">
                  <button
                    className="mobile_menu_btn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#main_menu_dropdown"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    onClick={() => setMobailState(!mobailActive)}
                  >
                    <i className="far fa-bars"></i>
                  </button>
                </li>
                <li className="d-none d-lg-block">
                  <a
                    className="ico_btn_outline"
                    href="https://app.crucoin.ai/login"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="btn_icon">
                      <i className="fa-solid fa-user"></i>
                    </span>
                    <span className="btn_label">Ingresar</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
